import "./clientSettings.scss";

import { observer, useLocalObservable } from "mobx-react";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import { Form, Divider, Row, Col, Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title } = Typography;

const FormContent = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {}, []);

  const columns = 3; // Number of columns per row
  const gutter = [16, 16]; // Space between rows and columns

  const state = useLocalObservable(() => ({}));

  const renderForm = () => {
    const { handleSettingsFields, clientSettingsFormRef } = controller;
    const { dataStructure, selectedOption, editProfile } = controller.clientSettingsModal;
    console.log("editProfile", editProfile);

    let elements = [];
    let rowElements = [];

    if (dataStructure[selectedOption].length > 0) {
      dataStructure[selectedOption].forEach((field, index) => {
        if (field.data) {
          rowElements.push(
            <Col key={field.key + "_" + index} span={24 / columns}>
              <Title level={5} className="clientSettingsFormTitle">
                {field.label}
                {field?.description && (
                  <Tooltip placement="top" title={field.description}>
                    <InfoCircleOutlined className="clientSettingsFormInfoIcon" />
                  </Tooltip>
                )}
              </Title>
              {handleSettingsFields(field)}
            </Col>
          );
        } else {
          elements.push(
            <Col key={field.key + "_" + index} span={24 / columns}>
              <Title level={5} className="clientSettingsFormTitle">
                {field.label}
                {field?.description && (
                  <Tooltip placement="top" title={field.description}>
                    <InfoCircleOutlined className="clientSettingsFormInfoIcon" />
                  </Tooltip>
                )}
              </Title>
              {handleSettingsFields(field)}
            </Col>
          );
        }
      });
    }

    return (
      <Form className="clientSettingsForm" form={clientSettingsFormRef} disabled={true}>
        {elements.length > 0 ? (
          <Row gutter={[16, 16]} key={"fieldSet1"} className="clientSettingsFormRow">
            {elements}
          </Row>
        ) : null}

        {rowElements.length > 0 ? (
          <Row gutter={[16, 16]} key={"fieldSet2"} className="clientSettingsFormRow">
            {rowElements}
          </Row>
        ) : null}
      </Form>
    );
  };

  return renderForm();
});

export default FormContent;
